// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"mobilesignup2style_mainContainer__1vzUa"};